<template>
  <div class="layoutFullWidth">
    <main-menu/>
    <div id="new_main">
      <router-view name="default"/>
      <transition name="slide">
        <router-view name="detail"/>
      </transition>
      <transition name="slide2">
        <router-view name="detail2"/>
      </transition>
      <vue-progress-bar></vue-progress-bar>
    </div>
  </div>
</template>

<script>
  import authenService from "./services/authenService";
  import MainMenu from "./components/menu-left/main-menu";
  import fcmMixin from "./firebase/fcmMixin";

  export default {
    name: "app-new",
    components: {MainMenu},
    mixins: [fcmMixin],

    computed: {
      userDeptRoleId() {
        return this.$route.params.userDeptRoleId;
      },
      userDeptRoles() {
        return this.$store.getters.userDeptRoles;
      }
    },

    data() {
      return {};
    },

    created() {
      this.doRouting();
    },

    methods: {
      doRouting() {
        if (!this.userDeptRoles || !this.userDeptRoles.length) {
          authenService
            .storeStateBeforeLogin(this.$route)
            .then(() => this.$router.replace({name: "beforeEnterApp"}));
        } else {
          this.$store.commit("changeUserDeptRole", this.userDeptRoleId);
          this.$store.commit("getWorkspaceApps");
          this.$store.commit("getTenantLogo");
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/App.vue